import { darken, lighten } from 'polished';

export default (function (baseTheme) {
  var defaultBorder = darken(baseTheme.colorOffsetDark, baseTheme.colors.gray[7]);
  var primaryBorder = darken(baseTheme.colorOffsetDark, baseTheme.colors.blue[4]);
  var successBorder = darken(baseTheme.colorOffsetDark, baseTheme.colors.green[6]);
  var warningBorder = darken(baseTheme.colorOffsetDark, baseTheme.colors.orange[6]);
  var dangerBorder = darken(baseTheme.colorOffsetDark, baseTheme.colors.red[3]);

  var defaultHoverBackground = darken(baseTheme.colorOffsetDark, baseTheme.colors.gray[7]);
  var defaultActiveBackground = darken(baseTheme.colorOffsetDark, defaultHoverBackground);
  var primaryActiveBackground = darken(baseTheme.colorOffsetDark, baseTheme.colors.blue[3]);
  var successActiveBackground = darken(baseTheme.colorOffsetDark, baseTheme.colors.green[5]);
  var warningActiveBackground = darken(baseTheme.colorOffsetDark, baseTheme.colors.orange[4]);
  var dangerActiveBackground = darken(baseTheme.colorOffsetDark, baseTheme.colors.red[2]);

  return {
    fontSize: (parseFloat(baseTheme.fontSize) - 1) / parseFloat(baseTheme.fontSize) + 'rem',
    fontWeight: baseTheme.weightNormal,
    paddingTop: '0.6em',
    paddingRight: '1em',
    paddingBottom: '0.53em',
    paddingLeft: '1em',
    spacing: '0.4rem',
    borderSize: '1px',
    display: 'inline-block',
    position: 'relative',
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    background: 'transparent',
    lineHeight: 1.2,
    textAlign: 'center',
    webkitTextStroke: 0, // This makes white text in buttons hard to read, so removing it
    webkitFontSmoothing: 'subpixel-antialiased',
    userSelect: 'none',
    cursor: 'pointer',
    transitionProperty: 'background-color,border-color,color',
    transitionDuration: '200ms',
    transitionTimingFunction: 'ease',
    border: 'none',
    maxWidth: 'initial',
    float: 'none',

    // Disabled
    disabledBorder: darken(baseTheme.colorOffsetDark, baseTheme.colors.gray[8]),
    disabledColor: lighten(0.3, baseTheme.colors.gray[8]),

    // Normal default state colors
    normal: {
      backgroundColor: {
        default: baseTheme.colors.gray[7],
        primary: baseTheme.colors.blue[4],
        success: baseTheme.colors.green[6],
        warning: baseTheme.colors.orange[6],
        danger: baseTheme.colors.red[3],
        inverted: {
          danger: 'transparent',
          primary: 'transparent'
        }
      },

      borderColor: {
        default: defaultBorder,
        primary: primaryBorder,
        success: successBorder,
        warning: warningBorder,
        danger: dangerBorder,
        inverted: {
          danger: baseTheme.colors.gray[7],
          primary: baseTheme.colors.gray[7]
        }
      },

      color: {
        default: baseTheme.colors.gray[1],
        primary: baseTheme.colors.white,
        success: baseTheme.colors.white,
        warning: baseTheme.colors.white,
        danger: baseTheme.colors.white,
        inverted: {
          danger: baseTheme.colors.red[3],
          primary: baseTheme.colors.blue[4]
        }
      }
    },

    // Hover
    hover: {
      backgroundColor: {
        default: defaultHoverBackground,
        primary: baseTheme.colors.blue[3],
        success: baseTheme.colors.green[5],
        warning: baseTheme.colors.orange[4],
        danger: baseTheme.colors.red[2],
        inverted: {
          danger: baseTheme.colors.red[3],
          primary: baseTheme.colors.blue[4]
        }
      },

      borderColor: {
        default: darken(baseTheme.colorOffsetDark, defaultBorder),
        primary: darken(baseTheme.colorOffsetDark, primaryBorder),
        success: darken(baseTheme.colorOffsetDark, baseTheme.colors.green[5]),
        warning: darken(baseTheme.colorOffsetDark, baseTheme.colors.orange[4]),
        danger: darken(baseTheme.colorOffsetDark, baseTheme.colors.red[2]),
        inverted: {
          danger: baseTheme.colors.red[2],
          primary: baseTheme.colors.blue[3]
        }
      },

      color: {
        default: baseTheme.colors.gray[1],
        primary: baseTheme.colors.white,
        success: baseTheme.colors.white,
        warning: baseTheme.colors.white,
        danger: baseTheme.colors.white,
        inverted: {
          danger: baseTheme.colors.white,
          primary: baseTheme.colors.white
        }
      }
    },

    // Active
    active: {
      backgroundColor: {
        default: defaultActiveBackground,
        primary: primaryActiveBackground,
        success: successActiveBackground,
        warning: warningActiveBackground,
        danger: dangerActiveBackground,
        inverted: {
          danger: 'transparent',
          primary: 'transparent'
        }
      },

      borderColor: {
        default: darken(baseTheme.colorOffsetDark, defaultActiveBackground),
        primary: darken(baseTheme.colorOffsetDark, primaryActiveBackground),
        success: darken(baseTheme.colorOffsetDark, successActiveBackground),
        warning: darken(baseTheme.colorOffsetDark, warningActiveBackground),
        danger: darken(baseTheme.colorOffsetDark, dangerActiveBackground),
        inverted: {
          danger: baseTheme.colors.gray[7],
          primary: baseTheme.colors.gray[7]
        }
      },

      color: {
        default: baseTheme.colors.gray[1],
        primary: baseTheme.colors.white,
        success: baseTheme.colors.white,
        warning: baseTheme.colors.white,
        danger: baseTheme.colors.white,
        inverted: {
          danger: baseTheme.colors.red[3],
          primary: baseTheme.colors.blue[4]
        }
      }
    },

    // Focus
    focus: {
      backgroundColor: {
        default: baseTheme.colors.gray[7],
        primary: baseTheme.colors.blue[4],
        success: baseTheme.colors.green[6],
        warning: baseTheme.colors.orange[6],
        danger: baseTheme.colors.red[3],
        inverted: {
          danger: 'transparent',
          primary: 'transparent'
        }
      },
      color: {
        default: baseTheme.colors.gray[1],
        primary: baseTheme.colors.white,
        success: baseTheme.colors.white,
        warning: baseTheme.colors.white,
        danger: baseTheme.colors.white,
        inverted: {
          danger: baseTheme.colors.red[3],
          primary: baseTheme.colors.blue[4]
        }
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-button/es/ButtonTheme.js
// module id = 1081
// module chunks = 1